// removed by extract-text-webpack-plugin
module.exports = {"lightgray":"lightgray__ZzEqO","gray":"gray__1h4E9","dark":"dark__2xpho","white":"white__2ZLuH","light":"light__11NJt","normal":"normal__1cWsX","medium":"medium__2uxr9","bold":"bold__2yB8F","left":"left__21Wib","center":"center__1V_E-","right":"right__18gZG"};


//////////////////
// WEBPACK FOOTER
// ./components/typography/style.css
// module id = szLA
// module chunks = 3